import { useTranslation } from 'react-i18next'

import { getBirdviewAttentionRowBodyContent } from './BirdviewAttentionRowBody.utils'

function BirdviewAttentionRowBody({
  emptyTextKey,
  extra,
  items,
  requestActions,
  state,
  onOpenItem,
  onRetry,
}) {
  const { t } = useTranslation()

  return getBirdviewAttentionRowBodyContent({
    emptyTextKey,
    extra,
    items,
    requestActions,
    state,
    t,
    onOpenItem,
    onRetry,
  })
}

export default BirdviewAttentionRowBody
